import RepositoryService from 'src/services/repository'

const resource = 'multiProject/session'

export default {
  ...RepositoryService.utils.createCrudRepository(resource),
}
